import React from 'react'
import PropTypes from 'prop-types'

const ChangesDisclaimer = ({ classes, disclaimer }) => {
  // Regexp:
  // 1e group: string until a '.' is found.
  // 2e group: string until the description ends.
  const description = disclaimer.match(/^(.*?\.)(.+)/)

  // When no match could be made return the disclaimer string
  if (!description || description.length < 3) {
    return <p className={classes.description}>{disclaimer}</p>
  }

  return (
    <p className={classes.description}>
      <strong>{description[1]}</strong>
      {description[2]}
    </p>
  )
}

ChangesDisclaimer.propTypes = {
  disclaimer: PropTypes.string.isRequired,
}

export default ChangesDisclaimer
